import React, { ReactNode, type JSX } from 'react';
import { DropPane, DropPaneProps } from '../DragDrop';
import { UploadButton as DefaultUploadButton } from './UploadButton';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

const defaultText = (
  <div className="flex flex-col items-center">
    <div className="text-content-primary text-[14px]">Drop your file(s) here</div>
  </div>
);

const defaultSizeWarning = (
  <div className="flex items-center justify-between text-content-secondary text-body-md">
    <p>Min 1Kb, Max 25Mb</p>
    <InformationCircleIcon className="ml-1 w-5 h-5 -mt-5" />
  </div>
);

export interface FileUploaderProps extends Omit<DropPaneProps, 'onDrop'> {
  handleFile: (file: File) => void;
  sizeWarning?: JSX.Element;
  text?: ReactNode;
  UploadButton?: (props: { disabled?: boolean; handleFile: (file: File) => void; accept: string[] }) => JSX.Element;
  accept?: string[];
  imgUrl?: string;
  className?: string;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  disabled,
  handleFile,
  text = defaultText,
  sizeWarning = defaultSizeWarning,
  UploadButton = DefaultUploadButton,
  accept = [],
  imgUrl,
  ...props
}) => (
  <DropPane className="text-center" onDrop={x => [...x.files].forEach(handleFile)} {...props}>
    {imgUrl ? (
      <img src={imgUrl} alt="Uploaded file" className="max-w-44 max-h-44 rounded-lg mt-4 mb-2" />
    ) : (
      <>
        {text}
        {sizeWarning}
      </>
    )}
    <UploadButton disabled={disabled} handleFile={handleFile} accept={accept} variant="secondary" />
  </DropPane>
);
